function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LiveContext } from 'react-live';
import { AlertDanger } from '@homeaway/react-alerts';
import "./LiveDemoError.css";

function createMsg(e) {
  return {
    __html: e
  };
}

var LiveDemoError = /*#__PURE__*/function (_Component) {
  _inheritsLoose(LiveDemoError, _Component);

  function LiveDemoError() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = LiveDemoError.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var error = this.context.error;

    if (error && this.oldError !== error) {
      this.props.onErrorChange(error);
    }

    this.oldError = error;
  };

  _proto.render = function render() {
    var error = this.context.error;
    var errorTitle = '';
    var errorMsg = '';

    if (error) {
      var index = error.search(/\n/); // Gets the index where the first newline occurs

      if (index !== -1) {
        errorTitle = error.substr(0, index);
        errorMsg = error.substr(index + 1).replace(/(?:\r\n|\r|\n)/g, '<br/>');
      }
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "LiveDemoError"
    }, errorTitle !== '' && /*#__PURE__*/React.createElement(AlertDanger, {
      svgMarkup: ""
    }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", {
      className: "LiveDemoError__title",
      dangerouslySetInnerHTML: createMsg(errorTitle)
    })), /*#__PURE__*/React.createElement("span", {
      className: "LiveDemoError__msg",
      dangerouslySetInnerHTML: createMsg(errorMsg)
    })));
  };

  return LiveDemoError;
}(Component);

LiveDemoError.propTypes = {
  onErrorChange: PropTypes.func
};
LiveDemoError.defaultProps = {
  onErrorChange: function onErrorChange() {}
};
LiveDemoError.contextType = LiveContext;
export default LiveDemoError;
//# sourceMappingURL=LiveDemoError.js.map